import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { JanelaRenuncia } from "src/app/model/janela-solicitacao-renuncia.model";
import { JanelaRenunciaResponseDto, Renuncia } from "src/app/model/renuncia.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

@Injectable({
    providedIn: 'root'
})
export class JanelaSolicitacaoRenunciaService extends FgiBackEndService<JanelaRenuncia> {

    getNewEntity() {
        return new JanelaRenuncia();
    }

    protected getResourceURL(): string {
        return 'front/janela-solicitacao-renuncia';
    }

    obterJanelasAtivas(): Observable<JanelaRenuncia[]> {
        return this.http.get(`${this.BASE_URL}/ativas`).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenuncia[] | null>;
    }

    obterJanela(): Observable<JanelaRenuncia> {
        return this.http.get(`${this.BASE_URL}/ativa`).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenuncia>;
    }

    obterJanelas(): Observable<JanelaRenuncia[]> {
        return this.http.get(`${this.BASE_URL}`).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenuncia[]>;
    }

    obterJanelasPorTipo(tipoJanela: string): Observable<JanelaRenuncia[]> {
        return this.http.get(`${this.BASE_URL}/tipo/${tipoJanela}`).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenuncia[]>;
    }

    salvar(janela: JanelaRenuncia): Observable<JanelaRenuncia> {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}`, janela, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<JanelaRenuncia>;
    }

    excluir(id: number): Observable<any> {
        const options = blockUi();
        return this.http.post(`${this.BASE_URL}/${id}`, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }
}
